import { Controller } from "@hotwired/stimulus"

// Invito.js: ogni invio comincia con setError(""): l'errore precedente sparisce subito, prima della risposta.
// salva() è acceptNew: dopo setError("") i controlli fatti nel browser, con gli stessi testi; se uno fallisce l'errore
// compare in invite-error e il form non parte (Turbo ignora l'invio con preventDefault). Il server li ripete per chi
// invia senza JavaScript.
export default class extends Controller {
  static targets = ["password", "conferma"]

  salva(event) {
    this.mostra("")
    let errore = ""
    if (this.passwordTarget.value.length < 8) errore = "La password deve avere almeno 8 caratteri."
    else if (this.passwordTarget.value !== this.confermaTarget.value) errore = "Le due password non coincidono."
    if (!errore) return
    event.preventDefault()
    this.mostra(errore)
  }

  pulisciErrore() {
    this.mostra("")
  }

  // Come inviti/_errore: il riquadro con il testo, oppure il segnaposto nascosto.
  mostra(testo) {
    const attuale = this.element.querySelector("#invite-error")
    if (!attuale) return
    const nuovo = document.createElement("div")
    nuovo.id = attuale.id
    if (testo) {
      nuovo.className = "text-sm text-rose-600"
      nuovo.dataset.testid = "invite-error"
      nuovo.textContent = testo
    } else {
      nuovo.hidden = true
    }
    attuale.replaceWith(nuovo)
  }
}
